/*
*###############################################################################
*Module Name                   : VoucherWriteOff.js                            #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : T A C Priyashad                               #
*Date                          : Monday, April 27th 2022, 13:14:01             #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect, useContext } from 'react'
import { MetaTags } from 'react-meta-tags'
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
} from 'reactstrap'

//**Importing required componant files   */
import Breadcrumb from 'components/Common/Breadcrumb'
import DPTopToolBar from 'framework/widgets/DPTopToolBar'
import VoucherWriteOffContent from './VoucherWriteOffContent'
import DPInfoBox from 'framework/layout/DPInfoBox'
import { Text } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from 'framework/widgets/DPPermission'
import * as XLSX from "xlsx";
import DPPrintOption from 'framework/widgets/DPPrintOptions'
//**End Importing required componant files */
import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';

import { SaveUpdateVoucherWriteOff, ValidateVoucherWriteOff } from './VoucherWriteOffController'
import { ValidateSingleVoucherWriteOff } from './VoucherWriteOffController'

const VoucherWriteOff = (props) => {

    let history = useHistory();
    const {
        getMenuDetails, masterAuditLog, addtoFavourite
    } = useContext(Context);
    //*** User input related states */
    const [strEthniCode, SetCode] = useState("");// Set Code
    const [strEthniDesc, SetDescription] = useState("")//Set Description
    const [IsActive, SetActive] = useState(true)//Set Active state
    const [menuCode, SetMenuCode] = useState("")
    //*** End User input related states */

    //*** User Activity related states*/
    const [show, setShow] = useState(false)
    const [AlertMsg, setAlertMsg] = useState('')
    const [AlertColor, setAlertColor] = useState('')
    const [Post, SetPost, getPost] = useState([])
    const [modal_xlarge, setmodal_xlarge] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [disabledCode, setDisabledCode] = useState(false)
    const [saveEnable, setSaveEnable] = useState(true)
    const [crEnable, setCrEnable] = useState(false)
    const [crBy, setCrBy] = useState("")
    const [mdBy, setMdBy] = useState("")
    const [crDate, setCrDate] = useState("")
    const [mdDate, setMdDate] = useState("")
    const [deleteEnable, SetDeleteEnable] = useState(false)
    const [Reason, setReason] = useState("Created")
    const [editEnable, SetEditEnable] = useState(false)
    //*** End User activity related staes */

    //Alert Parameters
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [ErrorMsg, setErrorMsg] = useState('')
    const [addNew, SetAddNew] = useState(true)

    //*****Menu Rights Start*/
    const [menuAccess, SetMenuAccess] = useState(false)
    const [menuCreate, SetMenuCreate] = useState(false)
    const [menuDelete, SetMenuDelete] = useState(false)
    const [menuModify, SetMenuModify] = useState(false)
    const [menuPrint, SetMenuPrint] = useState(false)
    const [menuProcess, SetMenuProcess] = useState(false)
    const [menuName, SetMenuName] = useState("")
    const [parentName, SetParentName] = useState("")
    const [LocationCode, setLocationCode] = useState("")
    const [LogUserType, setLogUserType] = useState("")
    const [LogCompanyCode, setLogCompanyCode] = useState("")
    //*****Menu Rights End */

    /**********Loading Alert */
    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
    /**********End Loading Alert */

    //autocode generation related newly added code
    const [codeButton, setCodeButton] = useState(true)
    const [searchdisabled, setSearchdisabled] = useState(false)
    const [nullCode, setNullCode] = useState(false)
    const [autoCode, setAutoCode] = useState(false)

    //User Permission related usestates
    const [permissionAlertShow, setPermissionAlertShow] = useState(false)
    const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
    const [permissionReasonShow, setPermissionReasonShow] = useState(false)
    const [permissionName, setPermissionName] = useState("")
    const [permissionPassword, setPermissionPassword] = useState("")
    const [permissionNameDisable, setPermissionNameDisable] = useState(false)

    const [printoptionShow, setprintoptionShow] = useState(false)

    const [valueUpload, setvalueUpload] = useState("")
    const [items, setItems] = useState([]);
    const [Excelitems, setExcelItems] = useState([]);
    const [voucherList, setVoucherList] = useState([])
    const [errorList, setErrorList] = useState([])

    const [selectAllChecked, setSelectAllChecked] = useState(false);
    const [placeholder, setPlaceholder] = useState("Search by Voucher Code")
    const [searchString, setSearchString] = useState("")
    const [currentPage, setCurrentPage] = useState(1)
    const [showCheckbox, setShowCheckbox] = useState(false)

    const [openErrorList, setOpenErrorList] = useState(false)
    const [voucherCode, setVoucherCode] = useState("");

    const authToken = localStorage.getItem("authToken")

    const ApiURL = window.Links.ApiURL
    const [helpUrl, setHelpUrl] = useState("")
    var time = process.env.REACT_APP_ALERTTIMEOUT


    //**Get File Details */
    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName
        SetParentName(parentname)
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        setLocationCode(LocationCode)
        setLogUserType(LogUserType)
        setLogCompanyCode(CompanyCode)

        var requestOptions = {
            method: 'GET',
            headers: {
                "Authorization": `Bearer ${authToken}`
            },
            redirect: 'follow'
        };

        fetch(`${ApiURL}login/menu/${LogUserType}/${menu}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                SetMenuAccess(result.data.strMenuAccessRight)
                SetMenuCreate(result.data.strMenuCreateRight)
                SetMenuDelete(result.data.strMenuDeleteRight)
                SetMenuModify(result.data.strMenuModifyRight)
                SetMenuPrint(result.data.strMenuPrintRight)
                SetMenuProcess(result.data.strMenuProcessRight)
                SetMenuName(result.data.strMenuName)
                SetMenuCode(result.data.strMenuTag)
                setPermissionReasonShow(result.data.strMenuReasonShow)
                setHelpUrl(result.data.strHelpUrl)
                fetch(`${ApiURL}common/autocode/${result.data.strMenuTag}`, {
                    method: "GET",
                    headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                }).then(Response => Response.json())
                    .then(responseData => {
                        if (responseData.success == true) {
                            if (responseData.data.length == 0) {
                                setNullCode(true)
                            } else {
                                setAutoCode(responseData.data)
                            }
                        }
                    })
            }).catch(error =>
                console.log('error', error)
            );
    }, [strEthniCode])


    // AuditLog
    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push("/dashboard")

        await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
    }, [])


    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var LocationName = obj[4]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName
        var menuTAG = ""
        const AuditLog = {
            "strMenuCode": menu,
            "strUserName": LogUserType,
            "strLocCode": LocationCode,
            "strComcode": CompanyCode,
            "strReason": ""
        }
        var requestOptions = {
            method: 'POST',
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
            body: JSON.stringify(AuditLog),
        };

        fetch(`${ApiURL}login/menu/audit`, requestOptions)
            .then(async (response) => await response.json())
            .then(result => {
                console.log(result)
            }).catch(error =>
                console.log('error', error)
            );
    }, [])


    const readExcel = (file) => {
        const promise = new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsArrayBuffer(file);

            fileReader.onload = (e) => {
                const bufferArray = e.target.result;
                const wb = XLSX.read(bufferArray, { type: "buffer" });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = XLSX.utils.sheet_to_json(ws);

                //read excel data and assign them to an array
                const dataSet = []
                data.forEach((item, index) => {
                    dataSet.push({
                        "id": index + 1,
                        "strCode": item.CODE.toString(),
                        "strDesc": "",
                        "dcValue": "",
                        "blStatus": false,
                        "strComment": "",
                        "selected": false
                    })
                })

                //setVoucherList(dataSet)
                ValidateVoucher(dataSet)
                setShowCheckbox(true)
                setvalueUpload("")
                setCurrentPage(1)
                resolve(data);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
        promise.then((d) => {
            setItems(d);
        });
    };


    //checkbox activity
    const onCheckboxChange = (id) => {
        const updatedDataRow = [...voucherList];
        const selectedIndex = updatedDataRow.findIndex(item => item.id == id)
        updatedDataRow[selectedIndex].selected = !updatedDataRow[selectedIndex].selected;
        setVoucherList(updatedDataRow);
    }


    const onCommentChange = (id, value) => {
        const updatedDataRow = [...voucherList];
        const selectedIndex = updatedDataRow.findIndex(item => item.id == id)
        updatedDataRow[selectedIndex].strComment = value;
        setVoucherList(updatedDataRow);
    }

    const applytoAll = (value) => {

        const updatedList = voucherList.map((item) => {
            if (item.selected) {
                item.strComment = value
            }
            return item
        })

        setVoucherList(updatedList)

    }


    //select all checkboxes activity
    const handleSelectAllChange = (e) => {
        var updatedList = voucherList.map((item) => {
            if (!item.blCanceled) {
                item.selected = e.target.checked
            }
            return item
        })
        setVoucherList(updatedList)
    };


    //search bar activity
    const filteredData = voucherList.filter((item) => {
        if (searchString === "") {
            return true;
        } else if (
            typeof item.strCode === "string" &&
            item.strCode.toLowerCase().includes(searchString.toLowerCase())
        ) {
            return true;
        } else {
            return false;
        }
    });

    const ValidateVoucher = async (excelVoucherList) => {

        const vouchers = excelVoucherList.map(item => ({
            "VWO_CODE": item.strCode.toString()
        }));

        const jsonBody = { "VoucherWriteOff": vouchers };

        try {
            SetLoadingAlert(true);
            SetLoadingAlerttitle("Loading...");

            const response = await ValidateVoucherWriteOff(jsonBody);

            // Early return if success is false
            if (!response.success) {
                displayAlertMessage('danger', "Something went wrong!");
                return;
            }

            const { vlist: dataArray, elist } = response;

            setVoucherList(dataArray);

            if (elist.length > 0) {
                setErrorList(elist);
                setOpenErrorList(true);
            }

        } catch (e) {
            displayAlertMessage('danger', "Something went wrong!");
        } finally {
            SetLoadingAlert(false);
        }
    };


    //hadle voucher code input
    const handleVoucherCodeChange = (e) => {
        setVoucherCode(e.target.value)
    };


    //Add Button - validate single voucher code
    const validateSingleVoucher = async () => {

        if(voucherCode == "") {
            displayAlertMessage('danger', "Voucher code is required!");
            return;
        }

        if (voucherList.some(item => item.strCode == voucherCode)) {
            displayAlertMessage('danger', "Voucher code already exists!");
            setVoucherCode("")
            return;
        }

        const jsonBody = { VWO_CODE: voucherCode };

        try {
            SetLoadingAlert(true);
            SetLoadingAlerttitle("Validating...");
            let response = await ValidateSingleVoucherWriteOff(jsonBody);

            if (response.success) {

                let newData = response.data;
                let dataList = [...voucherList];

                let maxID = 0
                voucherList.forEach((item) => {
                    if (item.id > maxID) {
                        maxID = item.id
                    }
                })

                newData.id = maxID + 1

                dataList.push(newData);
                setVoucherList(dataList)

                setVoucherCode("")
            } else {
                displayAlertMessage('danger', "Invalid voucher code !")
                setVoucherCode("")
            }
        } catch (e) {
            displayAlertMessage('danger', "Something went wrong !")
            setVoucherCode("")
        } finally {
            SetLoadingAlert(false);
        }

    }


    //*** Get and Set values when user search code */
    function getData(searchData) {
        if (searchData != "") {
            SetLoadingAlert(true)
            SetLoadingAlerttitle("Fetching...")
            fetch(`${ApiURL}Ethnicity/search/${searchData}`, {
                method: "GET",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` }
            }).then(Response => Response.json())
                .then(responseData => {
                    SetLoadingAlert(false)
                    if (responseData.success == true) {
                        const newArray = [...responseData.data]
                        SetPost(newArray)
                        SetPost(state => {
                            state.map(
                                localState => (
                                    SetDescription(localState.name),
                                    SetActive(localState.status),
                                    setCrBy(localState.createdBy),
                                    setCrDate(localState.createdDate),
                                    setMdBy(localState.modifiedBy),
                                    setMdDate(localState.modifiedDate),
                                    setCrEnable(true)
                                )
                            )
                            SetAddNew(false)
                            setDisabled(true)
                            setDisabledCode(true)
                            setSaveEnable(false)
                            SetDeleteEnable(true)
                            setSearchdisabled(true)
                            setReason("Updated")
                            SetEditEnable(true)
                            return state
                        })
                    } else if (responseData.success == false) {
                        if (nullCode == false) {
                            displayAlertMessage('success', "Record Not Found !")
                            setDisabledCode(true)
                            SetCode("")
                        }
                    }
                })
        }
    }
    //*** End useEffect */


    function tog_xlarge() {
        setmodal_xlarge(!modal_xlarge)
        removeBodyCss()
    }


    //removebodyCss function
    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }


    //save button function
    const handlesave = async (e) => {
        const selectedVouchersArray = voucherList.filter((item) => item.selected);

        if (selectedVouchersArray.length > 0) {
            let selectedVouchers = [];
            selectedVouchersArray.forEach((item) => {
                selectedVouchers.push({
                    "VWO_CODE": item.strCode,
                    "VWO_COMMENT": item.strComment ?? ""
                });
            });

            const jsonBody = {
                "strReason": Reason,
                "strLoggedCompany": LogCompanyCode,
                "strLoggedLocation": LocationCode,
                "strCreateBy": LogUserType,
                "menuCode": menuCode,
                "VoucherWriteOff": selectedVouchers
            };

            SetLoadingAlert(true);
            SetLoadingAlerttitle("Saving...");

            let response = await SaveUpdateVoucherWriteOff(jsonBody);

            SetLoadingAlert(false);

            if (response.success == true) {
                displayAlertMessage('success', "Update Success !");
                ClearItem();
            } else {
                displayAlertMessage('danger', "Something went wrong !");
            }
        } else {
            displayAlertMessage('danger', "No vouchers selected!");
        }
    }



    //*** Get user selected row details */
    const GetSelectRow = (row, isSelect, rowIndex, e) => {
        SetCode(row.code);
        getData(row.code)
        setDisabled(true)
        setDisabledCode(true)
        setSaveEnable(false)
        setmodal_xlarge(!modal_xlarge);
        setCrBy(row.crby)
        setMdBy(row.mdby)
        setCrDate(row.crdate)
        setMdDate(row.mddate);
        setCrEnable(true)
    }
    //*** End of getSelectedRow function */


    //edit button function    
    const handleEdit = e => {
        setDisabled(false)
        setDisabledCode(true)
        setSaveEnable(true)
        SetDeleteEnable(true)
        SetEditEnable(false)

    }


    //new button function
    const handleNew = e => {
        //e.preventDefault()
        ClearItem();
        setShow(false)
        setSaveEnable(true)
        setCrEnable(false)
    }


    //clear fields function    
    const ClearItem = () => {
        SetCode("")
        SetDescription("")
        SetActive(true)
        setDisabledCode(false)
        setDisabled(false)
        setCrEnable(false)
        SetAddNew(true)
        setErrorMsg('')
        SetDeleteEnable(false)
        SetDeleteEnable(false)
        setNullCode(false)
        setSearchdisabled(false)
        SetEditEnable(false)
        setReason("Created")
        SetEditEnable(false)
        setSaveEnable(true)
        setPermissionName("")
        setPermissionPassword("")
        setPermissionNameDisable(false)
        setCodeButton(true)
        setExcelItems([])
        setPlaceholder("Search by Voucher Code")
        setSearchString("")
        setvalueUpload("")
        setVoucherCode("")
        setSearchString("")
        setVoucherList([])
        setTimeout(() => {
            setExcelItems([])
        }, 1)
        setCurrentPage(1)
    }

    //********Delete button function */
    const handleDelete = () => {
        const rowDelete = {
            "strMenuCode": menuCode,
            "strCode": strEthniCode,
            "strLoggedCompany": LogCompanyCode,
            "strLoggedLocation": LocationCode,
            "strReason": Reason,
            "strCreateBy": LogUserType
        }
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Deleting...")

        fetch(`${ApiURL}Common/Delete`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                body: JSON.stringify(rowDelete)
            }
        ).then(Response => {
            if (Response.status == "200") {
                SetLoadingAlert(false)
                Response.json()
                    .then(responseData => {
                        console.log(responseData)
                        if (responseData.data == "Cannot Delete, Record Already Used!") {
                            displayAlertMessage('warning', responseData.data)
                        } else {
                            ClearItem()
                            displayAlertMessage('success', responseData.data)
                        }
                    }
                    )
            } else if (Response.status == "400") {
                SetLoadingAlert(false)
                Response.json()
                    .then(responseData => {
                        setErrorMsg(responseData.msg)
                    })
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Error !")
            } else {
                SetLoadingAlert(false)
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }
    //*********Delete button function end */

    // print Function
    async function handlePrint(option) {
        var option = option
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Generating Report...")

        const ReportURL = window.Links.ReportURL
        await fetch(`${ReportURL}api/Ethnicity/report/${LogUserType}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` }
        }).then(Response => Response.json())
            .then(responseData => {
                if (responseData.success == true) {
                    if (option == "PDF") {
                        const msg = responseData.msg
                        window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
                    }
                    if (option == "XCEL") {
                        const msg = responseData.msg
                        window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xls`)
                    }
                }
                SetLoadingAlert(false)
            })
    }

    //CODE AUTO GEN
    const AutoGenerateCode = async () => {
        await fetch(`${ApiURL}common/autocode/${menuCode}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
        }).then(Response => Response.json())
            .then(responseData => {
                if (responseData.success == true) {
                    if (responseData.data.length > 0) {
                        SetCode(responseData.data)
                    } else {
                        setDisabledCode(false)
                    }
                }
            })
    }


    //**Permission Check */
    const permission = (operation) => {
        const permissiondata = {
            strUsername: permissionName,
            strPassword: permissionPassword,
            strLocation: LocationCode,
            strMenuCode: menuCode
        }

        clearPermissionInputs()

        fetch(`${ApiURL}login/userpermission`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                body: JSON.stringify(permissiondata)
            }
        ).then(Response => {
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {
                        console.log(responseData.data)
                        let Access = (responseData.data.strMenuAccessRight)
                        let Create = (responseData.data.strMenuCreateRight)
                        let Delete = (responseData.data.strMenuDeleteRight)
                        let Modify = (responseData.data.strMenuModifyRight)
                        let Print = (responseData.data.strMenuPrintRight)
                        let Process = (responseData.data.strMenuProcessRight)

                        if (operation == "Save") {
                            if (Create == true) {
                                handlesave()
                            } else if (Modify == true) {
                                handlesave()
                            } else {
                                if (operation == "Save" && addNew == true) {
                                    displayAlertMessage('danger', "This user dosen't have permission to save")
                                } else {
                                    displayAlertMessage('danger', "This user dosen't have permission to edit")
                                }
                            }
                        } else if (operation == "Delete") {
                            if (Delete == true) {
                                handleDelete()
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to delete !")
                            }
                        } else if (operation == "Print") {
                            if (Print == true) {
                                setprintoptionShow(true)
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to print !")
                            }
                        }
                    }
                    )
            } else if (Response.status == "400") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Oops something went wrong !")
                clearPermissionInputs()

            } else if (Response.status == "403") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "You have not Permission to make changes !")
                clearPermissionInputs()

            } else if (Response.status == "404") {
                setDisabled(false)
                setDisabledCode(false)
                displayAlertMessage('danger', "Password or User Name is Invalid !")
                clearPermissionInputs()

            } else {
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }



    //excel file upload & read data
    function showFileUpload(e) {
        const file = e.target.files[0];
        if (!file) {
            console.error("No file selected.");
            return;
        }
        readExcel(file);
        setvalueUpload(e.target.value);
    }

    //Function for display Alert Messages
    function displayAlertMessage(color, message) {
        setAlertColor(color)
        setAlertMsg(message)
        setShow(true)
        setTimeout(() => {
            setShow(false)
        }, time)
    }

    //handle permission alert
    function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
        setPermissionName(LogUserType)
        setReason(reason)
        setPermissionNameDisable(disable)
        setPermissionAlertShow(alertShow)
    }

    //Clear permission name & password
    function clearPermissionInputs() {
        setPermissionName("");
        setPermissionPassword("");
        setReason("");
    }

    //Handle Favourite Button
    const handleFavourite = async () => {
        var response = await addtoFavourite(menuCode, LogUserType);
        console.log(response)
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{menuName}</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumb title={parentName} breadcrumbItem={menuName}></Breadcrumb>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <DPAlert
                                        confirm_both={sweetAlertShow}
                                        title={menuName}
                                        description={AlertDescription}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        onConfirm={() => {
                                            setsweetAlertShow(false)
                                            if (AlertConfirmOption == 1) {
                                                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Created", true, true)
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                                                    handlesave()
                                                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Updated", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            } else if (AlertConfirmOption == 2) {
                                                handleEdit()
                                            } else if (AlertConfirmOption == 3) {
                                                window.location.href = "/";
                                            } else if (AlertConfirmOption == 4) {
                                                handleNew()
                                            } else if (AlertConfirmOption == 6) {
                                                if (menuPrint == true && permissionReasonShow == false) {
                                                    setprintoptionShow(true)
                                                } else if (menuPrint == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Printed", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            } else if (AlertConfirmOption == 5) {
                                                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                                                    handleDelete()
                                                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                                                    handlePermissionAlert(LogUserType, "Deleted", true, true)
                                                } else {
                                                    setPermissionReasonShow(true)
                                                    setPermissionAlertShow(true)
                                                }
                                            }
                                        }}
                                        onCancel={() => {
                                            setsweetAlertShow(false)
                                            clearPermissionInputs()
                                        }}
                                    />
                                    <DPPrintOption
                                        confirm_both={printoptionShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        cancelColor={"danger"}
                                        onConfirmpdf={() => {
                                            handlePrint("PDF")
                                            setprintoptionShow(false)
                                        }}
                                        onConfirmxcel={() => {
                                            handlePrint("XCEL")
                                            setprintoptionShow(false)
                                        }}
                                        onCancel={() => {
                                            setprintoptionShow(false)
                                        }}
                                    />
                                    <DPPermission
                                        confirm_both={permissionAlertShow}
                                        title={menuName}
                                        description={permissionAlertTitle}
                                        showReason={permissionReasonShow}
                                        nameDisable={permissionNameDisable}
                                        showCancel={true}
                                        btnColor={"success"}
                                        cancelColor={"danger"}
                                        AlName={permissionName}
                                        AlNameOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setPermissionName(val2)
                                        }}
                                        AlPassward={permissionPassword}
                                        AlPasswardOnchange={e => {
                                            let val2 = Text(e.target, 50, true, true, "any", true)
                                            setPermissionPassword(val2)
                                        }}
                                        AlReason={Reason}
                                        AlReasonOnchange={e => {
                                            let val2 = Text(e.target, 50, true, false, "any", true)
                                            setReason(val2)
                                        }}
                                        onConfirm={() => {
                                            setPermissionAlertShow(false)
                                            if (AlertConfirmOption == 1) {
                                                permission("Save")
                                            } else if (AlertConfirmOption == 5) {
                                                permission("Delete")
                                            } else if (AlertConfirmOption == 6) {
                                                permission("Print")
                                            }
                                        }}
                                        onCancel={() => {
                                            setPermissionAlertShow(false)
                                            clearPermissionInputs()
                                        }}
                                    />
                                    <DPLoadingAlert
                                        confirm_both={loadingAlert}
                                        title={loadingAlertTitle}
                                    />
                                    <DPTopToolBar
                                        //Help Button
                                        helpEnable={helpUrl != "" ? true : false}
                                        helpClick={() => {
                                            window.open(helpUrl)
                                        }}
                                        //Favorite Button
                                        favoriteEnable={true}
                                        favoriteClick={handleFavourite}
                                        //New Button
                                        newEnable={true}
                                        newClick={() => {
                                            setAlertDescription("Do you wish to refresh the screen ?");
                                            setAlertConfirmOption(4)
                                            setsweetAlertShow(true)
                                        }}
                                        //Save Button
                                        saveEnable={saveEnable}
                                        saveClick={() => {
                                            setAlertDescription("Do you wish to save ?");
                                            setAlertConfirmOption(1)
                                            setsweetAlertShow(true)
                                        }}
                                        //ProcessButton
                                        processEnable={false}
                                        processClick={() => {
                                            alert("Process")
                                        }}
                                        //Edit Button
                                        editEnable={editEnable}
                                        editClick={() => {
                                            setAlertDescription("Do you wish to edit ?");
                                            setAlertConfirmOption(2)
                                            setsweetAlertShow(true)
                                        }}
                                        //Print Button
                                        printEnable={true}
                                        printClick={() => {
                                            setReason("Printed")
                                            setAlertDescription("Do you wish to print ?");
                                            setAlertConfirmOption(6)
                                            setsweetAlertShow(true)
                                        }}
                                        //Delete Button
                                        deleteEnable={deleteEnable}
                                        deleteClick={() => {
                                            setReason("Deleted")
                                            setAlertDescription("Do you wish to delete ?");
                                            setAlertConfirmOption(5)
                                            setsweetAlertShow(true)
                                        }}
                                        //Exit Button
                                        exitEnable={true}
                                        exitClick={() => {
                                            setAlertDescription("Do you wish to exit ?");
                                            setAlertConfirmOption(3)
                                            setsweetAlertShow(true)
                                        }}
                                    />
                                    <Row>
                                        <VoucherWriteOffContent
                                            GetSelectRow={GetSelectRow}
                                            CodeValue={strEthniCode}
                                            CodeonChange={e => {
                                                let val1 = Text(
                                                    e.target,
                                                    5,
                                                    true,
                                                    false,
                                                    "upper",
                                                    false
                                                )
                                                SetCode(val1)
                                            }}
                                            DescValue={strEthniDesc}
                                            DescOnChange={e => {
                                                let val2 = Text(
                                                    e.target,
                                                    50,
                                                    true,
                                                    false,
                                                    "any",
                                                    true
                                                )
                                                SetDescription(val2)
                                            }}
                                            ActiveSw={IsActive}
                                            SwonChange={() => {
                                                SetActive(!IsActive)
                                            }}
                                            modelTrigger={tog_xlarge}
                                            modelOpen={modal_xlarge}
                                            show={show}
                                            disabled={disabled}
                                            disabledCode={disabledCode}
                                            AlertColor={AlertColor}
                                            AlertMsg={AlertMsg}
                                            CodeOnBlur={e => {
                                                getData(e.target.value)
                                            }}
                                            ErrorMsg={ErrorMsg}
                                            menuName={menuName}
                                            onButtonClick={e => {
                                                AutoGenerateCode()
                                                setCodeButton(true)
                                            }}
                                            btnDisable={codeButton}
                                            SearchDisable={searchdisabled}
                                            showFileUpload={showFileUpload}
                                            valueUpload={valueUpload}
                                            filteredData={filteredData}
                                            onCheckboxChange={onCheckboxChange}
                                            onCommentChange={onCommentChange}
                                            applytoAll={applytoAll}
                                            selectAllChecked={selectAllChecked}
                                            handleSelectAllChange={handleSelectAllChange}
                                            placeholder={placeholder}
                                            searchString={searchString}
                                            setSearchString={setSearchString}
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                            showCheckbox={showCheckbox}
                                            errorList={errorList}
                                            openErrorList={openErrorList}
                                            setOpenErrorList={setOpenErrorList}
                                            handleVoucherCodeChange={handleVoucherCodeChange}
                                            voucherCode={voucherCode}
                                            handleAddButton={validateSingleVoucher}
                                        />
                                    </Row>
                                    <Row>
                                        {crEnable ? (
                                            <DPInfoBox
                                                createdBy={crBy}
                                                createdOn={crDate != '1900-01-01T00:00:00' ? crDate : ''}
                                                modifiedBy={mdBy}
                                                modifiedOn={mdDate != '1900-01-01T00:00:00' ? mdDate : ''}
                                            />
                                        ) : null}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default VoucherWriteOff